export const EmployeesData = [
  {
    id: 1,
    contactNumber: "09340678836",
    department: { value: "engineering", label: "Engineering" },
    designation: { value: "developer", label: "Developer" },
    dob: "2024-04-20",
    email: "ashishingle589@gmail.com",
    firstName: "Ashish",
    gender: "male",
    joiningDate: "2024-08-17",
    lastName: "Ingle",
  },
];
